<div class="container">
  @for (key of locationKeys; track key) {
    <div
      class="selection"
      (click)="onSelection(key)"
      >
      {{key}}
    </div>
  }
</div>
